export default __webpack_public_path__ + "static/media/Forward.168157a1.svg";